import { Component, Input, Output, EventEmitter } from '@angular/core';
@Component({
  selector: 'app-fehlermeldung',
  templateUrl: './Fehlermeldung.component.html',
  styleUrls: ['./Fehlermeldung.component.css']
})
export class FehlermeldungComponent {
  public zeigeFehlerMeldung = false;
  @Input() FehlerUeberschrift: string;
  @Input() FehlerHinweis: string;
  @Input()
  get zeigeFehlerMeldungSchalter() { return this.zeigeFehlerMeldung; }
  set zeigeFehlerMeldungSchalter(val) {
    this.zeigeFehlerMeldung = val;
    this.zeigeFehlerMeldungSchalterChange.emit(this.zeigeFehlerMeldung);
  }
  @Output() zeigeFehlerMeldungSchalterChange = new EventEmitter();
  @Input() FehlerCallback: Function;
  constructor() {
  }
  fehlerBestaetigt() {
    this.zeigeFehlerMeldungSchalter = false;
    this.FehlerCallback();
  }
}
